export default __webpack_public_path__ + "static/media/Lowest.ed7ff349.png";